"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.TimeType = exports.ResponseCode = exports.Engagement_Test_Client = exports.Engagement_NotificationTemplates_Client = exports.Engagement_NotificationSubtype_Client = exports.Engagement_Times_Client = exports.Engagement_Reciever_Client = exports.Engagement_PersonalNotification_Client = exports.Engagement_NotificationTypes_Client = exports.Engagement_GlobalNotification_Client = exports.Engagement_WebHook_Client = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = __importDefault(require("axios"));
var Engagement_WebHook_Client = /** @class */ (function () {
    function Engagement_WebHook_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Consume Pubsub Messages (Scope: Dashboard)
     */
    Engagement_WebHook_Client.prototype.webHook_post_V1 = function (pushBody, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/WebHook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pushBody);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebHook_post_V1(_response);
        });
    };
    Engagement_WebHook_Client.prototype.processWebHook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_WebHook_Client;
}());
exports.Engagement_WebHook_Client = Engagement_WebHook_Client;
var Engagement_GlobalNotification_Client = /** @class */ (function () {
    function Engagement_GlobalNotification_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get my all global notifications (Auth) (Scope: Mobile)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_GlobalNotification_Client.prototype.globalNotification_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/GlobalNotification?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGlobalNotification_get_V1(_response);
        });
    };
    Engagement_GlobalNotification_Client.prototype.processGlobalNotification_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Unsubscribe to this type of Global Notification (Auth policies: 10.1)
     */
    Engagement_GlobalNotification_Client.prototype.unsubscribe_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/GlobalNotification/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnsubscribe_V1(_response);
        });
    };
    Engagement_GlobalNotification_Client.prototype.processUnsubscribe_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all global notifications paginated for admin (Auth policies: 10.1) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_GlobalNotification_Client.prototype.globalNotification_V1GET = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/GlobalNotification?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGlobalNotification_V1GET(_response);
        });
    };
    Engagement_GlobalNotification_Client.prototype.processGlobalNotification_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create global Notification based on segment (Auth policies: 10.1) (Scope: Dashboard)
     */
    Engagement_GlobalNotification_Client.prototype.globalNotification_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/GlobalNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGlobalNotification_V1POST(_response);
        });
    };
    Engagement_GlobalNotification_Client.prototype.processGlobalNotification_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update created global notification properties (Auth policies: 10.1) (Scope: Dashboard)
     */
    Engagement_GlobalNotification_Client.prototype.globalNotification_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/GlobalNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGlobalNotification_V1PUT(_response);
        });
    };
    Engagement_GlobalNotification_Client.prototype.processGlobalNotification_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_GlobalNotification_Client;
}());
exports.Engagement_GlobalNotification_Client = Engagement_GlobalNotification_Client;
var Engagement_NotificationTypes_Client = /** @class */ (function () {
    function Engagement_NotificationTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get Receiver notificationType (Auth policies: 46.6) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_NotificationTypes_Client.prototype.receiver_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTypes/receiver";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReceiver_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processReceiver_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all notificationTypes (Auth policies: 46.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_get_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Receiver notificationType (Auth policies: 46.5) (Scope: Mobile)
     * @param input new notificationType
     */
    Engagement_NotificationTypes_Client.prototype.set_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTypes/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSet_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processSet_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Receiver notificationType (Auth policies: 46.5) (Scope: Mobile)
     * @param input new notificationType
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_set_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_set_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_set_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Receiver notificationType (Auth policies: 46.6) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_receiver_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes/receiver";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_receiver_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_receiver_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new notificationType (Auth policies: 46.1)
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_V1POST(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing notificationType (Auth policies: 46.2) (Scope: Dashboard)
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_V1PUT(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all notificationTypes (Auth policies: 46.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_V1GET = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_V1GET(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete notificationType (Auth policies: 46.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_V1DELETE = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_V1DELETE(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all notificationTypes paginated for admin (Auth policies: 46.7)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_paginated_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_paginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get notificationType by id (Auth policies: 46.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_NotificationTypes_Client.prototype.notificationTypes_id_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTypes_id_V1(_response);
        });
    };
    Engagement_NotificationTypes_Client.prototype.processNotificationTypes_id_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_NotificationTypes_Client;
}());
exports.Engagement_NotificationTypes_Client = Engagement_NotificationTypes_Client;
var Engagement_PersonalNotification_Client = /** @class */ (function () {
    function Engagement_PersonalNotification_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get My personal notifications based on My User segments (Scope: Mobile)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_PersonalNotification_Client.prototype.personalNotification_get_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/PersonalNotification?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPersonalNotification_get_V1(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processPersonalNotification_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete My personal notification (Scope: Mobile)
     */
    Engagement_PersonalNotification_Client.prototype.personalNotification_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/PersonalNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPersonalNotification_delete_V1(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processPersonalNotification_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Stop Receiving this type of Personal Notification (Auth policies: 10.1) (Scope: Mobile)
     */
    Engagement_PersonalNotification_Client.prototype.unsubscribe_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/PersonalNotification/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnsubscribe_V12(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processUnsubscribe_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete user specific personal notification (Scope: Mobile)
     */
    Engagement_PersonalNotification_Client.prototype.personalNotification_V1DELETE = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/PersonalNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPersonalNotification_V1DELETE(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processPersonalNotification_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Personal Notification for Specific User ID , Specific User Group (Auth policies: 10.1) (Scope: Mobile)
     */
    Engagement_PersonalNotification_Client.prototype.personalNotification_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/PersonalNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPersonalNotification_V1POST(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processPersonalNotification_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Personal Notification for Specific User ID , Specific User Group (Auth policies: 10.1) (Scope: Mobile)
     */
    Engagement_PersonalNotification_Client.prototype.personalNotification_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/PersonalNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPersonalNotification_V1PUT(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processPersonalNotification_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete All personal Notifications Belong to User Id (Auth policies: 10.1) (Scope: Mobile)
     */
    Engagement_PersonalNotification_Client.prototype.personalNotification_bulk_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/PersonalNotification/bulk";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPersonalNotification_bulk_V1(_response);
        });
    };
    Engagement_PersonalNotification_Client.prototype.processPersonalNotification_bulk_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_PersonalNotification_Client;
}());
exports.Engagement_PersonalNotification_Client = Engagement_PersonalNotification_Client;
var Engagement_Reciever_Client = /** @class */ (function () {
    function Engagement_Reciever_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Set Player Id (Auth policies: 67.0) (Scope: Mobile)
     * @param input playerId
     */
    Engagement_Reciever_Client.prototype.setPlayerId_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Reciever/set-player-id";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetPlayerId_V1(_response);
        });
    };
    Engagement_Reciever_Client.prototype.processSetPlayerId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_Reciever_Client;
}());
exports.Engagement_Reciever_Client = Engagement_Reciever_Client;
var Engagement_Times_Client = /** @class */ (function () {
    function Engagement_Times_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Set Receiver time (Auth policies: 42.5) (Scope: Mobile)
     * @param input new time
     */
    Engagement_Times_Client.prototype.set_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSet_V12(_response);
        });
    };
    Engagement_Times_Client.prototype.processSet_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Receiver time (Auth policies: 42.6) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_Times_Client.prototype.receiver_V12 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times/receiver";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReceiver_V12(_response);
        });
    };
    Engagement_Times_Client.prototype.processReceiver_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all times (Auth policies: 42.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_Times_Client.prototype.times_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTimes_get_V1(_response);
        });
    };
    Engagement_Times_Client.prototype.processTimes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new time (Auth policies: 42.1) (Scope: Dashboard)
     */
    Engagement_Times_Client.prototype.times_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTimes_post_V1(_response);
        });
    };
    Engagement_Times_Client.prototype.processTimes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing time (Auth policies: 42.2) (Scope: Dashboard)
     */
    Engagement_Times_Client.prototype.times_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTimes_put_V1(_response);
        });
    };
    Engagement_Times_Client.prototype.processTimes_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete time (Auth policies: 42.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Engagement_Times_Client.prototype.times_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTimes_delete_V1(_response);
        });
    };
    Engagement_Times_Client.prototype.processTimes_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get time by id (Auth policies: 42.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Engagement_Times_Client.prototype.id_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1(_response);
        });
    };
    Engagement_Times_Client.prototype.processId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all times paginated for admin (Auth policies: 42.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_Times_Client.prototype.paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Times/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V1(_response);
        });
    };
    Engagement_Times_Client.prototype.processPaginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_Times_Client;
}());
exports.Engagement_Times_Client = Engagement_Times_Client;
var Engagement_NotificationSubtype_Client = /** @class */ (function () {
    function Engagement_NotificationSubtype_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all global notifications subtype (Auth policies: 10.1) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_NotificationSubtype_Client.prototype.notificationSubtype_V1GET = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationSubtype?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationSubtype_V1GET(_response);
        });
    };
    Engagement_NotificationSubtype_Client.prototype.processNotificationSubtype_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new NotificationSubtype (Auth policies: 10.1) (Scope: Dashboard)
     */
    Engagement_NotificationSubtype_Client.prototype.notificationSubtype_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationSubtype";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationSubtype_V1POST(_response);
        });
    };
    Engagement_NotificationSubtype_Client.prototype.processNotificationSubtype_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing Notification Subtype (Auth policies: 10.1) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_NotificationSubtype_Client.prototype.notificationSubtype_V1PUT = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationSubtype?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationSubtype_V1PUT(_response);
        });
    };
    Engagement_NotificationSubtype_Client.prototype.processNotificationSubtype_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Notification Subtype by Id (Auth policies: 10.1) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Engagement_NotificationSubtype_Client.prototype.notificationSubtype_id_V1 = function (id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/admin/NotificationSubtype/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationSubtype_id_V1(_response);
        });
    };
    Engagement_NotificationSubtype_Client.prototype.processNotificationSubtype_id_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_NotificationSubtype_Client;
}());
exports.Engagement_NotificationSubtype_Client = Engagement_NotificationSubtype_Client;
var Engagement_NotificationTemplates_Client = /** @class */ (function () {
    function Engagement_NotificationTemplates_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new notificationTemplate (Auth policies: 10.1) (Scope: Dashboard)
     */
    Engagement_NotificationTemplates_Client.prototype.notificationTemplates_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_post_V1(_response);
        });
    };
    Engagement_NotificationTemplates_Client.prototype.processNotificationTemplates_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing notificationTemplate (Auth policies: 10.2) (Scope: Dashboard)
     */
    Engagement_NotificationTemplates_Client.prototype.notificationTemplates_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_put_V1(_response);
        });
    };
    Engagement_NotificationTemplates_Client.prototype.processNotificationTemplates_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all notificationTemplates (Auth policies: 10.0) (Scope: Dashboard)
     */
    Engagement_NotificationTemplates_Client.prototype.notificationTemplates_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_get_V1(_response);
        });
    };
    Engagement_NotificationTemplates_Client.prototype.processNotificationTemplates_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete notificationTemplate (Auth policies: 10.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Engagement_NotificationTemplates_Client.prototype.notificationTemplates_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTemplates_delete_V1(_response);
        });
    };
    Engagement_NotificationTemplates_Client.prototype.processNotificationTemplates_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get notificationTemplate by id (Auth policies: 10.4) (Scope: Dashboard)
     */
    Engagement_NotificationTemplates_Client.prototype.id_V12 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/NotificationTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V12(_response);
        });
    };
    Engagement_NotificationTemplates_Client.prototype.processId_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_NotificationTemplates_Client;
}());
exports.Engagement_NotificationTemplates_Client = Engagement_NotificationTemplates_Client;
var Engagement_Test_Client = /** @class */ (function () {
    function Engagement_Test_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new time (Auth)
     */
    Engagement_Test_Client.prototype.test_post_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/engagement/v1/Test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_post_V1(_response);
        });
    };
    Engagement_Test_Client.prototype.processTest_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Engagement_Test_Client;
}());
exports.Engagement_Test_Client = Engagement_Test_Client;
/** 0 = Success 400 = BadRequest 403 = Forbidden 404 = NotFound 404 = UserNotFound 404 = RoleNotFound 404 = RoleClaimNotFound 405 = Unauthorized 406 = NotAcceptable 407 = MaxNumberOfSimultaneousLogins 410 = DeletionNotAllowed 411 = AlreadyExist 412 = InvalidEmail 413 = InvalidCode 414 = EmailTaken 415 = UserBlocked 416 = InvalidCredentials 417 = InvalidPassword 500 = InternalServerError */
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    ResponseCode[ResponseCode["Forbidden"] = 403] = "Forbidden";
    ResponseCode[ResponseCode["NotFound"] = 404] = "NotFound";
    ResponseCode[ResponseCode["UserNotFound"] = 404] = "UserNotFound";
    ResponseCode[ResponseCode["RoleNotFound"] = 404] = "RoleNotFound";
    ResponseCode[ResponseCode["RoleClaimNotFound"] = 404] = "RoleClaimNotFound";
    ResponseCode[ResponseCode["Unauthorized"] = 405] = "Unauthorized";
    ResponseCode[ResponseCode["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseCode[ResponseCode["MaxNumberOfSimultaneousLogins"] = 407] = "MaxNumberOfSimultaneousLogins";
    ResponseCode[ResponseCode["DeletionNotAllowed"] = 410] = "DeletionNotAllowed";
    ResponseCode[ResponseCode["AlreadyExist"] = 411] = "AlreadyExist";
    ResponseCode[ResponseCode["InvalidEmail"] = 412] = "InvalidEmail";
    ResponseCode[ResponseCode["InvalidCode"] = 413] = "InvalidCode";
    ResponseCode[ResponseCode["EmailTaken"] = 414] = "EmailTaken";
    ResponseCode[ResponseCode["UserBlocked"] = 415] = "UserBlocked";
    ResponseCode[ResponseCode["InvalidCredentials"] = 416] = "InvalidCredentials";
    ResponseCode[ResponseCode["InvalidPassword"] = 417] = "InvalidPassword";
    ResponseCode[ResponseCode["InternalServerError"] = 500] = "InternalServerError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 0 = Morning 1 = Evening */
var TimeType;
(function (TimeType) {
    TimeType[TimeType["Morning"] = 0] = "Morning";
    TimeType[TimeType["Evening"] = 1] = "Evening";
})(TimeType = exports.TimeType || (exports.TimeType = {}));
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
